import React, { useCallback } from 'react'
import cx from 'classnames'

import { Text } from 'components/dataDisplay'
import { WidthContainer } from 'components/layout'

import PlanCard from './components/PlanCard/PlanCard'


type UpgradeCompactBlockProps = {
  title: Intl.Message
  text: Intl.Message
  plans: SubscriptionModule.UpgradePlan[]
  onPlanSelect: (plan: SubscriptionModule.UpgradePlan) => void
}

// TODO Move these compact view to compositions/blocks/UpgradeLargeBlock/UpgradeLargeBlock if ab test is successful - added on 2022-09-20 by vivanov
const UpgradeCompactBlock: React.FC<UpgradeCompactBlockProps> = (props) => {
  const { title, text, plans, onPlanSelect } = props

  const handlePlanSelect = useCallback((plan: SubscriptionModule.UpgradePlan) => {
    onPlanSelect(plan)
  }, [ onPlanSelect ])


  // should be at least 2 - current and with higher value
  if (!plans || plans.length < 2) {
    return null
  }

  return (
    <div className="bg-light-beige pt-16 pb-40">
      <WidthContainer className="text-center">
        <Text message={title} style="h4" />
        <Text className="mt-24 max-w-560 mx-auto" message={text} style="p2" />
        <div className="mt-24 grid gap-16">
          {
            plans.map((data) => (
              <PlanCard
                key={data.id}
                data={data}
                onClick={handlePlanSelect}
              />
            ))
          }
        </div>
      </WidthContainer>
    </div>
  )
}


export default UpgradeCompactBlock
